import Stack from '@zenbusiness/zui/Stack';

function WidgetArea({ children }) {
  return (
    <Stack
      sx={{
        gap: { xs: '1rem', sm: '1.5rem' }
      }}
    >
      {children}
    </Stack>
  );
}

export default WidgetArea;
